import * as Models from "../../ts/rlAdmin.models";
import { ReportService } from "../../services/report-service";
import { AdHocCustomPopupProcessor } from "./adhoc-custom-popup-processor";

export class AdHocTreeCustomPopupController {
    static $inject = ["$scope", "$location", "$window", "$log", "reportService"];

    private customPopupProcessor: AdHocCustomPopupProcessor;

    public dataList: Models.IAdHocFilterTreeNode[] = [];
    public selectedValues: Models.IAdHocFilterTreeNode[] = [];
    public selectedIds: string[] = [];

    private existingValue: string | number | string[] = null;

    constructor(
        public $scope: ng.IScope,
        public $location: ng.ILocationService,
        public $window: ng.IWindowService,
        public $log: ng.ILogService,
        public reportService: ReportService) {

        this.customPopupProcessor = new AdHocCustomPopupProcessor($window);
        this.getTreeData();

        return;
    }

    public get allValues(): string {

        if (this.selectedValues == null)
            return "";
        if (this.selectedValues.length === 1)
            return this.selectedValues[0].value;

        return _.map(this.selectedValues, m => m.value).join();
    }

    public init() {
        var columnName: string = this.customPopupProcessor.getColumnName();
        this.existingValue = this.customPopupProcessor.getExistingValue(columnName);
    }

    private getTreeData() {

        var fullColumnName: string = this.customPopupProcessor.getColumnName();

        this.reportService.getAdHocTreeFilter(fullColumnName)
            .then((result) => {
                this.dataList = _.uniq(result.data);
                this.selectedValues = this.getSelectedValuesFromString(this.existingValue, this.dataList);
                this.selectedIds = this.selectedValues.map(m => m.value);
            });
    }

    private getSelectedValuesFromString(existingValue: string | string[] | number, dataList: Models.IAdHocFilterTreeNode[]): Models.IAdHocFilterTreeNode[] {

        if (existingValue == null || existingValue === "" || existingValue === "...")
            return [];

        var ret: Models.IAdHocFilterTreeNode[] = [];
        var allValues: string[] = (<string>existingValue).split(',');

        allValues.forEach(val => {
            var treeNode: Models.IAdHocFilterTreeNode = this.findNode(val, dataList);
            if (treeNode != null) {
                ret.push(treeNode);
            }
        });

        return ret;
    }

    private findNode(findValue: string, dataList: Models.IAdHocFilterTreeNode[]): Models.IAdHocFilterTreeNode {

        if (dataList == null)
            return null;

        for (var i = 0; i < dataList.length; ++i) {

            var node = dataList[i];

            if (node == null)
                continue;

            if (node.value != null && node.value === findValue)
                return node;

            if (node.children != null) {
                node = this.findNode(findValue, node.children);  // recursively check children
                if (node != null)
                    return node;
            }
        }

        return null;
    }
}
